import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
/* Warning if you've imported this file on React Native */

if (process.env.NODE_ENV !== 'production' && typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'react-reduce-motion' on React Native.\n" + "Perhaps you're looking to import 'react-reduce-motion/native'?");
}

function useReduceMotion() {
  var _React$useState = React.useState(window.matchMedia('(prefers-reduced-motion: reduce)').matches),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      matches = _React$useState2[0],
      setMatch = _React$useState2[1];

  React.useEffect(function () {
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');

    var handleChange = function handleChange() {
      setMatch(mq.matches);
    };

    handleChange();
    mq.addEventListener('change', handleChange);
    return function () {
      mq.removeEventListener('change', handleChange);
    };
  }, []);
  return matches;
}

export { useReduceMotion };